import type { TraceKind, TraceStep } from "@mailhand/core/schemas";
import { fullTime } from "../../lib/format.js";

type StepTone = "neutral" | "green" | "amber" | "orange" | "blue";

const KIND_TONE: Record<TraceKind, StepTone> = {
  received: "neutral",
  parsed: "neutral",
  screened: "neutral",
  routed: "blue",
  input: "neutral",
  policy: "amber",
  approved: "green",
  rejected: "orange",
  overridden: "amber",
  resolved: "neutral",
  wrote: "blue",
  delivered: "blue",
  sent: "green",
  bounce: "orange",
  replayed: "amber",
  done: "green",
  followUp: "blue",
};

function detailValue(value: unknown): string {
  return typeof value === "string" ? value : JSON.stringify(value);
}

export function Timeline({ steps }: { steps: readonly TraceStep[] }) {
  if (steps.length === 0) return <p className="muted">Nothing recorded yet.</p>;
  return (
    <ol className="timeline">
      {steps.map((step) => (
        <li key={step.seq} className={`timeline-step tone-${KIND_TONE[step.kind]}`}>
          <span className="timeline-dot" aria-hidden="true" />
          <div className="timeline-body">
            <div className="timeline-meta mono">
              <span>{step.kind}</span>
              <time dateTime={step.at}>{fullTime(step.at)}</time>
            </div>
            <p className="timeline-text">{step.text}</p>
            {step.publicDetail === undefined || Object.keys(step.publicDetail).length === 0 ? null : (
              <details className="timeline-detail">
                <summary>Details</summary>
                <dl className="kv">
                  {Object.entries(step.publicDetail).map(([key, value]) => (
                    <div key={key} className="kv-row">
                      <dt>{key}</dt>
                      <dd className="mono">{detailValue(value)}</dd>
                    </div>
                  ))}
                </dl>
              </details>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
